export const NetLottery = {
  mod: "lottery",
  GetGameList: "GetGameList",
  GetIssueResultList: "GetIssueResultList",
  GetBetRecList: "GetBetRecList",
  Bet: "Bet",
  GetIssueResult: "GetIssueResult",
  GetIssueResNoProbability: "GetIssueResNoProbability",
  CollectGame: "CollectGame",
  GetCollectedGames: "GetCollectedGames",
  UnCollectGame: "UnCollectGame",
} as const;
export type TNetLottery = keyof typeof NetLottery;

export const NetOnline = {
  mod: "online",
  HeartBeat: "NA.heart_beat",
  Hello: "NA.Hello",
  Push: "push_nti",
} as const;
export type TNetOnline = keyof typeof NetOnline;

export const NetLogin = {
  mod: "loginV2",
  CheckVersion: "NA.CheckVersion",
  UserAccountLogin: "NA.UserAccountLogin",
  UserRegister: "NA.UserRegister",
  ForgetEmailPwd: "NA.ForgetEmailPwd",
  ForgetPwd: "NA.ForgetPwd",
  UserGoogleLogin: "NA.UserGoogleLogin",
  GetPhoneVerifyCode: "NA.GetPhoneVerifyCode",
  VerifyCodeEmail: "NA.VerifyCodeEmail",
  UserTokenLogin: "UserTokenLogin",
  Logout: "Logout",
  UserAccountLoginV2: "NA.UserAccountLoginV2",
  UserGoogleLoginV2: "NA.UserGoogleLoginV2",
  UserRegisterV2: "NA.UserRegisterV2",
  UserTokenLoginV2: "UserTokenLoginV2",
  UserAccountLoginV3: "NA.UserAccountLoginV3",
  UserGoogleLoginV3: "NA.UserGoogleLoginV3",
  CheckCountryAllowReg: "NA.CheckCountryAllowReg",
  CheckUserAccExists: "NA.CheckUserAccExists",
  UserRegisterV3: "NA.UserRegisterV3",
  UserTokenLoginV3: "NA.UserTokenLoginV3",
  GetTokenByVerifyCode: "NA.GetTokenByVerifyCode",
  VerifyRegCode: "NA.VerifyRegCode",
  NewForgetCodeCheck: "NA.NewForgetCodeCheck",
  NewForgetAccountPwd: "NA.NewForgetAccountPwd",
  NewBindPhone: "NewBindPhone",
  NewBindEmail: "NewBindEmail",
  AddAccountPwd: "AddAccountPwd",
  NewEditAccountPwd: "NewEditAccountPwd",
  GetFaceAuthCfgByCPFForForgetPwd: "NA.GetFaceAuthCfgByCPFForForgetPwd",
  ForgetPwdByCPF: "NA.ForgetPwdByCPF",
  UserLoginByFaceIndex: "NA.UserLoginByFaceIndex",
  GetFaceAuthCfgByLogin: "NA.GetFaceAuthCfgByLogin",
  UserStandardLogin: "NA.UserStandardLogin",
  CheckEnabledRegisterValidateCode: "NA.CheckEnabledRegisterValidateCode",
} as const;
export type TNetLogin = keyof typeof NetLogin;

export const NetPromoItem = {
  mod: "promoItem",
  GetUserPromoItemList: "GetUserPromoItemList",
  GetFreeUserPromoItemList: "GetFreeUserPromoItemList",
  UseUserPromoItem: "UseUserPromoItem",
} as const;
export type TNetPromoItem = keyof typeof NetPromoItem;

export const NetUserWealth = {
  mod: "userwealth",
  GetBindPutInfo: "GetBindPutInfo",
  GetUserPayChannelV2: "GetUserPayChannelV2",
  UserApplyPayV2: "UserApplyPayV2",
  GetUserPayUrlV2: "GetUserPayUrlV2",
  PayPageOpenStatus: "PayPageOpenStatus",
  GetWithdrawChannelV3: "GetWithdrawChannelV3",
  GetWithdrawChannelV4: "GetWithdrawChannelV4",
  UserApplyWithdrawV3: "UserApplyWithdrawV3",
  BindPutInfo: "BindPutInfo",
  BetPayGetHallUrl: "BetPayGetHallUrl",
  BetPayGetInfo: "BetPayGetInfo",
  GetPutTypesV2: "GetPutTypesV2",
  GetPutTypesV4: "GetPutTypesV4",
  RemovePutInfo: "RemovePutInfo",
  GetUserPayUrl: "GetUserPayUrl",
} as const;
export type TNetUserWealth = keyof typeof NetUserWealth;

export const NetFront = {
  mod: "front",
  GetUserInfo: "GetUserInfo",
  GetFrontCfgV2: "NA.GetFrontCfgV2",
  GetActivityConfig: "NA.GetActivityConfig",
  GetGameList: "NA.GetGameList",
  GetGameDetail: "NA.GetGameDetail",
  GetGameSimilar: "NA.GetGameSimilar",
  GetConfigVersion: "NA.GetConfigVersion",
  GetSysConfig: "NA.GetSysConfig",
  GetOffLineActivityConfig: "NA.GetOffLineActivityConfig",
  GetFrontConfig: "NA.GetFrontConfig",
  GetRecommendGameIds: "NA.GetRecommendGameIds",
  GetComponentList: "NA.GetComponentList",
  GetUserPayChannel: "GetUserPayChannel",
  GetGameRecord: "GetGameRecord",
  MyBonusTotal: "MyBonusTotal",
  MyBonusTransaction: "MyBonusTransaction",
  GetSpecialActivityRewards: "GetSpecialActivityRewards",
  ReceiveReward: "ReceiveReward",
  GetPage: "NA.GetPage",
  GetComponent: "NA.GetComponent",
  GetPageComponents: "NA.GetPageComponents",
  GetFrontMakers: "NA.GetFrontMakers",
  SetUserInfo: "SetUserInfo",
  GetLatestGameRecords: "NA.GetLatestGameRecords",
  GetUserInfoByUserID: "NA.GetUserInfoByUserID",
  GetUserInfoDetails: "GetUserInfoDetails",
  SetUserPrivacySetting: "SetUserPrivacySetting",
  GetUserLiveStats: "NA.GetUserLiveStats",
  PersonalizedGames: "PersonalizedGames", // 猜你喜欢
  GetPersonalizedBoards: "NA.PersonalizedBoards", // 猜你喜欢聚合榜单未登录
  PersonalizedBoards: "PersonalizedBoards", // 猜你喜欢聚合榜单登陆
  GetPersonalizedGames: "NA.PersonalizedGames", // 未登入 猜你喜欢
  GetPidInfo: "NA.GetPidInfo",
  GetAllLoginSessionsList: "GetAllLoginSessionsList",
  RemoveLoginDevice: "RemoveLoginDevice",
  ReceiveVipLevelUpReward: "ReceiveVipLevelUpReward",
  GetUserPoint: "GetUserPointV2",
  UpdateAwsS3UploadResult: "UpdateAwsS3UploadResult",
  GetGameWinRecord: "NA.GetGameWinRecord",
  GetRealtimeFiatExchangeCurrRates: "NA.GetRealtimeFiatExchangeCurrRates",
  GetUserRecord: "GetUserRecord",
  GetMsgList: "GetMsgList",
  ReadMsg: "ReadMsg",
  MyGameList: "MyGameList",
  EditUserInfo: "EditUserInfo",
  GetAwsS3PreSignUrl: "GetAwsS3PreSignUrl",
  UseGiftCode: "UseGiftCode",
  ManualExchangeBonus: "ManualExchangeBonus",
  GetUserShareUrl: "GetUserShareUrl",
  SaveSubscription: "SaveSubscription",
  SaveLoginAccount: "SaveLoginAccount",
  BindDefaultPointType: "BindDefaultPointType",
  SaveUserIdentifys: "SaveUserIdentifys",
  GetUserIdentifys: "GetUserIdentifys",
  DelUserIdentifys: "DelUserIdentifys",
  GetGameRecordByShareHash: "NA.GetGameRecordByShareHash",
  GetCloudflareValidation: "NA.GetCloudflareValidation",
  CollectGame: "CollectGame",
} as const;
export type TNetFront = keyof typeof NetFront;

export const NetExtGame = {
  mod: "extGame",
  EnterGame: "NA.EnterGame",
  ExitGame: "NA.ExitGame",
  GetPromoFeedData: "NA.GetPromoFeedData",
  SearchSportsData: "NA.SearchSportsData",
} as const;
export type TNetExtGame = keyof typeof NetExtGame;

export const NetNotice = {
  mod: "notice",
  GetMsgList: "GetMsgList",
  ReadMsg: "ReadMsg",
  ReadAllMsg: "ReadAllMsg",
  GetUnread: "GetUnread",
  GetMsgInfo: "GetMsgInfo",
} as const;
export type TNetNotice = keyof typeof NetNotice;

export const NetActivity = {
  mod: "activity",
  GetDetailsV2: "GetDetailsV2",
  GetAllRepeatConfig: "GetAllRepeatConfig",
  GetRepeatConfigNoAuth: "/NA.GetRepeatConfigNoAuth",
  GetAllRepeatConfigContainBasic: "GetAllRepeatConfigContainBasic",
  GetRepeatDetails: "GetRepeatDetails",
  GetHistory: "GetHistory",
  ShakeAwardHistory: "NA.ShakeAwardHistory",
  DoActive: "DoActive",
  GetUserRankDetails: "NA.GetUserRankDetails",
  GetUserRankHistory: "NA.GetUserRankHistory",
  GetAllAgentConfig: "GetAllAgentConfig",
  GetAgentDetails: "GetAgentDetails",
  DoAgentActive: "DoAgentActive",
  GetActivityStatus: "NA.GetActivityStatus",
  GetActivityConfig: "NA.GetActivityConfig",
  GetTurntableActivityBonusRecs: "NA.GetTurntableActivityBonusRecs",
  DoActivity: "DoActivity",
  GetAgentRewardRedDotData: "GetAgentRedDotData",
  GetRepeatConfigsByAtype: "NA.GetRepeatConfigsByAtype",
  GetUserRepeatRankHistory: "NA.GetUserRepeatRankHistory",
  GetUserRepeatRankDetails: "NA.GetUserRepeatRankDetails",
  GetRepeatDetailsByAtype: "GetRepeatDetailsByAtype",
} as const;
export type TNetActivity = keyof typeof NetActivity;

export const NetExtReport = {
  mod: "extReport",
  GetReportContent: "GetReportContent",
  ConfirmReport: "ConfirmReport",
} as const;
export type TNetExtReport = keyof typeof NetExtReport;

export const NetTask = {
  mod: "task",
  GetMyTaskActivityInfo: "GetMyTaskActivityInfo",
  GetUserTaskReward: "GetUserTaskReward",
  CompleteOnceTask: "CompleteOnceTask",
} as const;
export type TNetTask = keyof typeof NetTask;

export const NetResponsible = {
  mod: "responsible",
  // 获取负责任博彩相关用户的状态
  GetResponsibleUserStatus: "GetResponsibleUserStatus",
  // 获取用户自我限制设置
  GetUserSelfLimitSetting: "GetUserSelfLimitSetting",
  // 保存用户自我限制设置
  SaveUserSelfLimitSetting: "SaveUserSelfLimitSetting",
  // 移除用户自我限制设置周期
  RemoveUserSelfLimitSetting: "RemoveUserSelfLimitSetting",
} as const;

export type TNetResponsible = keyof typeof NetResponsible;

export const NetUserIDRisk = {
  mod: "userIDRisk",
  CheckKycStatus: "CheckKycStatus",
  GetUserAuthV2: "GetUserAuthV2",
  GetUserKycStatus: "GetUserKycStatus",
  ReportUserAuthData: "ReportUserAuthData",
  RequestActionStatus: "RequestActionStatus",
  RequestKycNotice: "RequestKycNotice",
  RequestKycPopInfo: "RequestKycPopInfo",
  VerifyIdentity: "VerifyIdentity",
  RequestFaceIndexPopInfo: "RequestFaceIndexPopInfo",
  GetUserIDVerificationState: "GetUserIDVerificationState",
  GetFaceIndexRes: "NA.GetFaceIndexRes",
} as const;
export type TNetUserIDRisk = keyof typeof NetUserIDRisk;

export const NetReward = {
  mod: "reward",
  ReceiveRewards: "ReceiveRewards",
  QueryReceiveRewardTaskStatus: "QueryReceiveRewardTaskStatus",
} as const;
export type TNetReward = keyof typeof NetReward;

export const NetUserAgent = {
  mod: "userAgent",
  activityGatewayMode: "activityGateway",
  GetAgentShareConfig: "GetAgentShareConfig",
  GetAppSentRewardAmountAnd40UserGotRecord:
    "NA.GetAppSentRewardAmountAnd40UserGotRecord",
  GetUserStatCombineForAgentActivity: "GetUserStatCombineForAgentActivity",
  AgencySummary: "AgencySummary",
  TeamCommissionData: "TeamCommissionData",
  CommissionDetailList: "CommissionDetailList",
  AgencyRewardDetail: "AgencyRewardDetail",
  DayCommissionList: "DayCommissionList",
  AgencyRewardList: "AgencyRewardList",
  LockedUserList: "LockedUserList",
  FriendVipList: "FriendVipList",
  ReceiveAgencyReward: "ReceiveAgencyReward",
  GetVipPrivilegesActivity: "GetVipPrivilegesActivity",
} as const;
export type TNetUserAgent = keyof typeof NetUserAgent;

export const NetCommon = {
  mod: "common",
  CheckCPFUsable: "NA.CheckCPFUsable",
  EncryptString: "NA.EncryptString",
  GetIdxPoppups: "NA.GetIdxPoppups",
  UpdateIdxPoppupReadTime: "UpdateIdxPoppupReadTime",
} as const;
export type TNetCommon = keyof typeof NetCommon;

export const NetMonopoly = {
  mod: "monopoly",
  GetMonopolyUrl: "GetMonopolyUrl",
} as const;
export type TNetMonopoly = keyof typeof NetMonopoly;
